import React, { Component } from 'react';
import SVGInline from 'react-svg-inline';

import Social from './Social';
export default class Footer extends Component {
	render() {
		return (
			<div className="container footer">
				<div className="social_footer">
					<Social />
				</div>
				<div className="data_footer">
					<h6 className="footerTxt">
						Diario de Cádiz
						<SVGInline
							className="copyright"
							svg={`<svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24"> <path fill="#5A5E61" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm4.4 13.5c-.6 1.8-2.3 3.1-4.3 3.1-2.5 0-4.6-2.1-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6 2 0 3.6 1.2 4.3 3h2.3c-.7-3-3.4-5.2-6.6-5.2-3.7 0-6.8 3-6.8 6.8 0 3.7 3 6.8 6.8 6.8 3.2 0 5.9-2.3 6.6-5.3h-2.3z" />
				</svg>`}
						/>
						<span className="año">2018</span>
					</h6>
					<p className="footerLast">Avda. del Puerto 2. Cádiz</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Footer.js